// Shared dashboard navigation configuration.
// Used by DashboardNav, MobileNav (dashboard variant), and CollapsibleSidebar.

export interface NavItem {
  href: string;
  label: string;
  icon: string;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const navSections: NavSection[] = [
  {
    title: "Organization",
    items: [
      { href: "/dashboard", label: "Overview", icon: "fa-solid fa-house" },
      { href: "/dashboard/credentials", label: "API Credentials", icon: "fa-solid fa-key" },
      { href: "/dashboard/team", label: "Team", icon: "fa-solid fa-users" },
      { href: "/dashboard/settings", label: "Settings", icon: "fa-solid fa-gear" },
    ],
  },
  {
    title: "Account",
    items: [
      { href: "/dashboard/profile", label: "Profile", icon: "fa-solid fa-user" },
      { href: "/dashboard/billing", label: "Billing", icon: "fa-solid fa-credit-card" },
    ],
  },
];

export const adminSection: NavSection = {
  title: "Admin",
  items: [
    { href: "/dashboard/admin/users", label: "Users", icon: "fa-solid fa-user-plus" },
    { href: "/dashboard/admin/etl-status", label: "ETL Status", icon: "fa-solid fa-server" },
  ],
};

/**
 * Returns all nav sections, including admin section if user is a superuser.
 */
export function getAllSections(isSuperuser: boolean): NavSection[] {
  return isSuperuser ? [...navSections, adminSection] : navSections;
}

/**
 * Collapsible sidebar uses a slightly different grouping — "Overview" in its own section.
 */
export const sidebarSections: NavSection[] = [
  {
    title: "Overview",
    items: [
      { href: "/dashboard", label: "Home", icon: "fa-solid fa-house" },
    ],
  },
  {
    title: "Organization",
    items: [
      { href: "/dashboard/credentials", label: "API Credentials", icon: "fa-solid fa-key" },
      { href: "/dashboard/team", label: "Team", icon: "fa-solid fa-users" },
      { href: "/dashboard/settings", label: "Settings", icon: "fa-solid fa-gear" },
    ],
  },
  {
    title: "Account",
    items: [
      { href: "/dashboard/profile", label: "Profile", icon: "fa-solid fa-user" },
      { href: "/dashboard/billing", label: "Billing", icon: "fa-solid fa-credit-card" },
    ],
  },
];

export function getAllSidebarSections(isSuperuser: boolean): NavSection[] {
  return isSuperuser ? [...sidebarSections, adminSection] : sidebarSections;
}
